const TEMPLATE_KEYS = new Set(['cover_letter'])

export function isTemplateKey(key?: string | null): boolean {
  if (key === undefined || key === null) return false
  return TEMPLATE_KEYS.has(key)
}
